export default "__VITE_ASSET__BJ0jh8Js__"